<template>
  <div class="drawer-wrapper">

    <el-drawer :wrapperClosable="true" :title="title" :close-on-click-modal="false" :visible.sync="dialogVisible" size="50%" :before-close="AddNone">

      <div class="demo-drawer__content">

        <el-form :model="editForm" size="medium" label-width="100px" class="mt35" :rules="rules" ref="userForm">

          <el-tabs v-model="activeName" style="margin-left: 30px;" @tab-click="handleClick">

            <el-tab-pane label="修改积分" name="first">

              <el-row :gutter="35">
                <el-col :xs="24" :sm="12" :md="8" :lg="15" :xl="22" class="mb20">
                  <el-form-item label="用户ID" prop="id">
                    <el-input v-model="editForm.id" :disabled="true" clearable></el-input>
                  </el-form-item>
                </el-col>

                <el-col :xs="24" :sm="12" :md="8" :lg="15" :xl="22" class="mb20">
                  <el-form-item label="增减类型" prop="type">
                    <template>
                      <el-radio v-model="editForm.inc_or_dec" @input="decRadio" label="1">增加积分</el-radio>
                      <el-radio v-model="editForm.inc_or_dec" @input="decRadio" label="0">减少积分</el-radio>
                    </template>
                  </el-form-item>
                </el-col>

                <el-col :xs="24" :sm="12" :md="8" :lg="15" :xl="22" class="mb20">
                  <el-form-item label="积分类型" prop="jfvalue">
                    <el-select v-model="editForm.jfvalue" @change="decSelect" placeholder="请选择">
                      <el-option
                          v-for="item in jfoptions"
                          :key="item.jfvalue"
                          :label="item.label"
                          :value="item.jfvalue">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>

                <el-col :xs="24" :sm="12" :md="8" :lg="15" :xl="22" class="mb20">
                  <el-form-item label="积分数量" prop="jf_number">
                    <el-input-number v-model="editForm.jf_number" controls-position="right" placeholder="请输入积分数量"
                                     clearable :min="0" :max="max"></el-input-number>
                    <br>
                    <span v-if="editForm.jfvalue=='1'"
                          style="color: #8c939d;font-size: 12px;">剩余<b>永久</b>积分:{{ userInfo.balance }}</span>
                    <span v-if="editForm.jfvalue=='0'"
                          style="color: #8c939d;font-size: 12px;">剩余<b>限时</b>积分:{{
                        userInfo.remain_free_balance
                      }}</span>
                  </el-form-item>
                </el-col>

                <el-col :xs="24" :sm="12" :md="8" :lg="15" :xl="22" class="mb20">
                  <el-form-item label="操作类型" prop="edit_type">
                    <el-select v-model="editForm.edit_type" placeholder="请选择">
                      <el-option
                          v-for="item in czoptions"
                          :key="item.czvalue"
                          :label="item.label"
                          :value="item.czvalue">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>

                <el-col :xs="24" :sm="12" :md="8" :lg="15" :xl="22" class="mb20">
                  <el-form-item label="备注" prop="notes">
                    <el-input
                        type="textarea"
                        :autosize="{ minRows: 2, maxRows: 4}"
                        placeholder="请输入内容"
                        v-model="editForm.notes">
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-row>

            </el-tab-pane>

            <el-tab-pane label="修改VIP" name="second">

              <el-row :gutter="35">

                <el-col :xs="24" :sm="12" :md="8" :lg="15" :xl="22" class="mb20">
                  <el-form-item label="用户ID" prop="id">
                    <el-input v-model="editForm.id" :disabled="true" clearable></el-input>
                  </el-form-item>
                </el-col>

                <el-col :xs="24" :sm="12" :md="8" :lg="15" :xl="22" class="mb20">
                  <el-form-item label="增减类型" prop="type">
                    <template>
                      <el-radio v-model="editForm.inc_or_dec" @input="dayRadio" label="1">增加VIP</el-radio>
                      <el-radio v-model="editForm.inc_or_dec" @input="dayRadio" label="0">减少VIP</el-radio>
                    </template>
                  </el-form-item>
                </el-col>

                <el-col :xs="24" :sm="12" :md="8" :lg="15" :xl="22" class="mb20">
                  <el-form-item label="VIP时长(天)" prop="day">
                    <el-input-number v-model="editForm.day" controls-position="right" placeholder="请输入VIP时长" clearable
                                     :min="0" :max="maxDay"></el-input-number>
                    <br>
                    <span style="color: #8c939d;font-size: 12px;">VIP到期时间:{{ userInfo.vip_expired_at }}</span>
                  </el-form-item>
                </el-col>

                <el-col :xs="24" :sm="12" :md="8" :lg="15" :xl="22" class="mb20">
                  <el-form-item label="操作类型" prop="edit_type">
                    <el-select v-model="editForm.edit_type" placeholder="请选择">
                      <el-option
                          v-for="item in czoptions"
                          :key="item.czvalue"
                          :label="item.label"
                          :value="item.czvalue">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>

                <el-col :xs="24" :sm="12" :md="8" :lg="15" :xl="22" class="mb20">
                  <el-form-item label="备注" prop="notes">
                    <el-input
                        type="textarea"
                        :autosize="{ minRows: 2, maxRows: 4}"
                        placeholder="请输入内容"
                        v-model="editForm.notes">
                    </el-input>
                  </el-form-item>
                </el-col>

              </el-row>

            </el-tab-pane>

          </el-tabs>

        </el-form>

      </div>

      <div class="demo-drawer__footer">
        <el-button @click="AddNone">取 消</el-button>
        <el-button type="primary" @click="addPush">确 定</el-button>
      </div>

    </el-drawer>

  </div>
</template>

<script>
import {userApi} from "@/api/user";
import {processErrors} from "@/utils/errorHandler";

export default {
  props: ['dialogVisible', "editID", "userInfo"],
  components: {},
  data() {
    return {
      title: "编辑",

      editForm: {
        id: this.editID,
        inc_or_dec: '1',
        jf_number: '',
        edit_type: '1',
        notes: '',
        day: '',
        jfvalue: '1',
      },

      rules: {
        jf_number: [
          {required: true, message: '请输入积分数量', trigger: 'blur'},
        ]
      },

      jfoptions: [{
        jfvalue: '1',
        label: '永久积分'
      }, {
        jfvalue: '0',
        label: '限时积分'
      }],

      czoptions: [{
        czvalue: '1',
        label: '系统操作'
      }, {
        czvalue: '2',
        label: '活动奖励'
      }],
      czvalue: '1',

      activeName: 'first',

      tabId: 0,
      max: 999999,
      maxDay: 999999,
    };
  },
  created() {
    this.handleClick({index: 0});
  },
  methods: {
    decRadio(val) {
      this.editForm.jf_number = '';
      if (val == 0) {
        let jfvalue = this.editForm.jfvalue;
        if (jfvalue == '1') {
          this.max = this.userInfo.balance;
        } else {
          this.max = this.userInfo.free_balance;
        }
      } else {
        this.max = 999999;
      }
    },

    decSelect(val) {
      this.editForm.jf_number = '';
      let inc_or_dec = this.editForm.inc_or_dec;
      if (inc_or_dec == '0') {
        let jfvalue = this.editForm.jfvalue;
        if (jfvalue == '1') {
          this.max = this.userInfo.balance;
        } else {
          this.max = this.userInfo.free_balance;
        }
      } else {
        this.max = 999999;
      }
    },

    dayRadio(val) {
      this.editForm.day = '';
      if (val == 0) {
        let dateString = this.userInfo.vip_expired_at;
        let today = new Date();
        let targetDate = new Date(dateString);
        if (targetDate > today) {
          this.maxDay = Math.ceil((targetDate - today) / (24 * 3600 * 1000));
        } else {
          this.maxDay = 0;
        }
      } else {
        this.maxDay = 999999;
      }
    },

    handleClick(tab, event) {
      this.rules = {}
      if (tab.index == 0) {//积分操作
        this.rules.jf_number = [
          {required: true, message: '请输入积分数量', trigger: 'blur'},
        ]

      } else if (tab.index == 1) {//vip操作

        this.rules.day = [
          {required: true, message: '请输入VIP时长(天)', trigger: 'blur'},
        ]

      }
      this.tabId = tab.index;
    },

    AddNone() {
      this.editForm = {
        id: this.editID,
        inc_or_dec: '1',
        jf_number: '',
        edit_type: '1',
        notes: '',
      }
      this.$refs['userForm'].resetFields();
      this.$emit('NoneDlog');
    },
    addPush() {
      let data = {
        user_id: this.editID,
        inc_or_dec: this.editForm.inc_or_dec,
        edit_type: this.editForm.edit_type,
        notes: this.editForm.notes,
      };
      if (this.tabId == 0) {
        data.type = 3;
        if (this.editForm.jfvalue == 1) {
          data.balance = this.editForm.jf_number;
        } else {
          data.free_balance = this.editForm.jf_number;
        }
      } else if (this.tabId == 1) {
        data.type = 4;
        data.day = this.editForm.day;
      }

      this.$refs['userForm'].validate((valid) => {
        if (valid) {
          let api = userApi();
          api.edit(data).then(res => {
            if (res.code == 0) {
              this.$message({
                message: '操作成功',
                type: 'success'
              });
              this.$emit('AddOk');
            } else {
              processErrors(res);
            }
          })
        } else {
          return false;
        }
      });

    },
  },

  mounted() {
  },
}
</script>
<style lang='scss' scoped>
.demo-drawer__content {
  height: calc(100% - 80px); /* 给内容区域设置高度,留出按钮区域 */
  overflow-y: auto; /* 添加垂直滚动条 */
  overflow-x: hidden;
}

.form-wrapper {
  padding-bottom: 80px; /* 给表单内容添加底部间距,留出按钮区域 */
}

.demo-drawer__footer {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 10px;
  text-align: center;
}

.demo-drawer__footer .el-button {
  margin: 0 10px;
  width: calc(50% - 20px);
}

::v-deep .el-drawer__close-btn{
  font-size: 30px;
  font-weight: bold;
}
</style>